import { FC } from 'react';

export const TableContents: FC = ({ children }) => (
  <div className="grid-wrapper" data-testid="datagrid">
    <table className="grid-table" style={{ minWidth: '700px' }}>
      {children}
    </table>
  </div>
);
